export default __webpack_public_path__ + "static/media/ic-medium.e002ba46.svg";